import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer className="bg-[#EFEFFD] md:px-[135px] px-[20px] md:pt-[80px] pt-[40px] md:pb-[60px] pb-[30px] overflow-hidden">
        <div className="grid md:grid-cols-2 grid-cols-1">
          <div>
            <img src="/assets/new logo.png" className="h-[150px]" alt="" />
          </div>
          <div>
            <h6 className="font-[500] md:text-[48px] text-[30px] md:leading-[58px] text-[#00725d] pb-[26px]">
            Dedicated to Creating <span className=" text-[#F8A340]"> and Success </span>Value
            </h6>
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[62px]">
            We are committed to delivering exceptional value and success to our clients. Our technology providers, industry experts, and strategic alliances play a crucial role in ensuring we consistently achieve outstanding results.
            </p>
          </div>
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-[38px]">
          <div className="flex gap-[14px] items-center flex-wrap">
        
<a target="blank" href="https://shorturl.at/vqGXm">

          <div className="social-icon">
          <i class="bi bi-instagram"></i>
          </div>
</a>
        
  
<a target="blank" href="https://shorturl.at/Yh6Tg">

          <div className="social-icon">
          <i class="bi bi-facebook"></i>
          </div>
          </a>
          
        
<a target="blank" href="https://shorturl.at/m9ne3">

          <div className="social-icon">
          <i class="bi bi-linkedin"></i>

          </div>
          </a>
   
<a target="blank" href="https://www.youtube.com/@VNIMembers">

          <div className="social-icon">
          <i class="bi bi-youtube"></i>


          </div>
          </a>

         
<a target="blank" href="https://x.com/vnimembers">


          <div className="social-icon">
          <i class="bi bi-twitter"></i>



          </div>
          </a>

            {/* <button className="bg-[#00725d] py-[6px] px-[15px] text-[#FFFFFF] rounded-[50px]">
              About
            </button>
            <button className="bg-[#00725d] py-[6px] px-[15px] text-[#FFFFFF] rounded-[50px]">
              Course
            </button>
            <button className="bg-[#00725d] py-[6px] px-[15px] text-[#FFFFFF] rounded-[50px]">
              Events
            </button>
            <button className="bg-[#00725d] py-[6px] px-[15px] text-[#FFFFFF] rounded-[50px]">
              Blogs
            </button>
            <button className="bg-[#00725d] py-[6px] px-[15px] text-[#FFFFFF] rounded-[50px]">
              Career
            </button> */}
          </div>
          <div className="flex md:flex-row flex-col gap-[15px] md:items-center items-start">
          <input type="email" className="bg-[#FFFFFF] rounded-[50px] max-w-[520px] w-full py-[14px] px-[27px] text-[#AFAFAF] font-[400] text-[16px]" placeholder="email address" />
            <button className="bg-[#00725d] py-[14px] px-[15px] text-[#FFFFFF] rounded-[50px]">
            Submit
            </button>
          </div>
        </div>
        <div className="md:my-[60px] my-[30px] border-t border-[#AFAFAF80]"></div>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-[20px]">
          <h6 className="text-[#00725d] font-[400] text-[14px] leading-[16.8px]">VNI All Rights Reserved. Powered by<span className="text-[#f8a340]   rounded-sm"> StrixDigital</span></h6>
          {/* <h6 className="text-[#00725d] font-[400] text-[14px] leading-[16.8px]"</h6> */}
        </div>
      </footer>
    </>
  );
}

export default Footer;
